import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { DadosUsuarioContext } from "../../providers/DadosDoUsuario";

export default function ProtectedRoutes() {
  const { token } = useContext(DadosUsuarioContext);

  return token ? <Outlet /> : <Navigate to="/" />;
}
